var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSourceLang = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 6.5C12.856 6.50869 13.6806 6.57795 14.2184 7.12968C14.8335 7.76062 14.8335 8.77608 14.8335 10.807V11.5251C14.8335 13.556 14.8335 14.5715 14.2184 15.2024C13.6033 15.8333 12.6134 15.8333 10.6335 15.8333H5.0335C3.0536 15.8333 2.06365 15.8333 1.44857 15.2024C0.833496 14.5715 0.833496 13.556 0.833496 11.5251L0.833496 10.807C0.833496 8.77608 0.833496 7.76061 1.44857 7.12968C1.98644 6.57795 2.81098 6.50869 4.3335 6.5",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83317 1.83301L7.83317 11.833M7.83317 11.833L5.49984 9.1407M7.83317 11.833L10.1665 9.1407",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSourceLang);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/source_lang.da685eb03261bea587cb8caa323710b6.svg";